import type { ReactNode } from "react";

/** The shared progressive-disclosure shell. It was extracted on the rule of three — the
 * roster's stats explainer, the counter view's explainer and the unit page's mitigation
 * walkthrough had each hand-rolled the same details/summary pair — and two of those three went
 * with the sections they belonged to on 2026-09-07 (the atlas presents data; it does not teach
 * the game's mechanics). One call site is left, the roster's "How are these stats computed?".
 * Kept rather than inlined back: what it holds is the per-column formula disclosures, which are
 * a figure explaining ITSELF, and that is the kind of disclosure the site keeps. */
export function Disclosure({ summary, children }: { summary: string; children: ReactNode }) {
  return (
    <details className="rounded-lg border border-line bg-surface px-4 py-3 text-[14px] text-ink-3">
      <summary className="cursor-pointer select-none font-mono text-[12px] uppercase tracking-[0.1em] text-ink-3 hover:text-ink-2">
        {summary}
      </summary>
      {children}
    </details>
  );
}
